const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
  })

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {Object} imageInfo - optional dimensions to scale image to, and image quality value between 0 and 1
 */
export default async function getCroppedImg(
  imageSrc: string,
  pixelCrop: { height: number; width: number; x: number; y: number },
  imageInfo?: { height?: number; width?: number; imageQuality?: number; outputFileType?: 'jpeg' | 'png' | 'webp' },
  fillColor = '#FFF',
): Promise<Blob | null> {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height
  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height
  const ctx = canvas.getContext('2d')

  if (!ctx || !canvas.width || !canvas.height) return null

  ctx.fillStyle = fillColor
  ctx.fillRect(0, 0, pixelCrop.width, pixelCrop.height)
  ctx.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height,
  )

  if (imageInfo && imageInfo.width && imageInfo.height) {
    const widthScaleRatio = imageInfo.width / image.width
    const heightScaleRatio = imageInfo.height / image.height

    ctx.scale(widthScaleRatio, heightScaleRatio)
  }

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        resolve(blob)
      },
      `image/${(imageInfo && imageInfo.outputFileType) || 'jpeg'}`,
      imageInfo && imageInfo.imageQuality ? imageInfo.imageQuality : 0.8,
    )
  })
}
